'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _propTypes = require('prop-types');

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _EntityMapper = require('../EntityMapper');

var _EntityMapper2 = _interopRequireDefault(_EntityMapper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deprecate = require('util-deprecate'); // tslint:disable-line:no-var-requires
var Paragraph = function Paragraph(_ref) {
    var mapper = _ref.mapper,
        uuid = _ref.uuid,
        page = _ref.page,
        index = _ref.index,
        paragraphProps = _ref.paragraphProps;
    return React.createElement(_EntityMapper2.default, { mapper: mapper, uuid: uuid, entityProps: (0, _assign2.default)({ index: index, page: page }, paragraphProps) });
};
Paragraph.propTypes = {
    index: PropTypes.number,
    mapper: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func]).isRequired,
    page: PropTypes.shape({}),
    paragraphProps: PropTypes.shape({}),
    uuid: PropTypes.string.isRequired
};
Paragraph.defaultProps = {
    index: 0,
    page: undefined,
    paragraphProps: {}
};
exports.default = deprecate(Paragraph, 'The Paragraph component is deprecated, use the EntityMapper component instead');
//# sourceMappingURL=Paragraph.js.map
